// This may need to be tweaked in order to support more than just "patient count", but for now it's fine.
import React, { useContext } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, SubTitle } from 'chart.js';
import Context from '../../../../utils/context';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, SubTitle);

const BarChart = ({ title, yTitle, xTitle, data }) => {
  const context = useContext(Context);
  const isMobile = context.viewport.getIsMobile();

  if (!data) {
    return <></>;
  }

  const colors = [
    '#59b6be',
    '#45a4c6',
    '#578ec5',
    '#7974b4',
    '#935791',
    '#9c3d62',
    '#69d9b0',
    '#324b4d',
    '#94b0b3',
    '#d393d2',
    '#c5a45b',
    '#0e6855',
    '#00a9be',
  ];

  const patientCount = data.total;
  const results = data.results;

  const options = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        font: {
          size: isMobile ? 10 : 12,
          family: 'Arial',
          color: '#666666',
        },
      },
      subtitle: {
        display: true,
        text: `${patientCount} total mentees`,
        font: {
          size: isMobile ? 10 : 12,
          family: 'Arial',
          color: '#666666',
        },
      },
      tooltip: {
        callbacks: {
          title: (context) => {
            return nonTrunctedLabels[context[0].dataIndex];
          },
          label: (context) => {
            return ' ' + context.formattedValue + ' patients';
          },
        },
        font: {
          size: isMobile ? 10 : 12,
          family: 'Arial',
          color: '#666666',
        },
      },
    },
    scales: {
      y: {
        display: true,
        title: {
          display: true,
          text: yTitle,
          padding: 0,
          color: '#666666',
          font: {
            size: isMobile ? 10 : 12,
            family: 'Arial',
          },
        },
        ticks: {
          font: {
            size: isMobile ? 10 : 12,
          },
          callback: function (_, index) {
            if (isMobile) {
              const label = nonTrunctedLabels[index];
              return label.length > 10 ? label.substring(0, 10) + '...' : label;
            }
            // For desktop, wrap text after 35 characters
            const label = nonTrunctedLabels[index];
            if (label.length > 35) {
              const words = label.split(' ');
              let lines = [];
              let currentLine = '';

              words.forEach((word) => {
                if ((currentLine + word).length > 35) {
                  lines.push(currentLine.trim());
                  currentLine = word + ' ';
                } else {
                  currentLine += word + ' ';
                }
              });
              if (currentLine) {
                lines.push(currentLine.trim());
              }
              return lines;
            }
            return label;
          },
          maxRotation: 0,
          minRotation: 0,
          padding: 10,
        },
      },
      x: {
        display: true,
        title: {
          display: true,
          text: xTitle,
          color: '#666666',
          font: {
            size: 12,
            family: 'Arial',
          },
        },
        ticks: {
          precision: 0,
        },
      },
    },
  };

  let labels = [];
  let values = [];
  let nonTrunctedLabels = [];

  Object.keys(results).forEach((label) => {
    let truncatedLabel = isMobile
      ? label.length > 15
        ? label.substring(0, 15) + '...'
        : label
      : label.length > 35
        ? label.substring(0, 35) + '...'
        : label;
    labels.push(truncatedLabel);
    nonTrunctedLabels.push(label); // for tooltip
    values.push(results[label]);
  });

  const chartData = {
    labels,
    nonTrunctedLabels,
    datasets: [
      {
        data: values,
        borderColor: colors,
        backgroundColor: colors,
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
};

export default BarChart;
